
import { animated, useTransition } from "@react-spring/web";
import PropTypes from "prop-types";

const AnimatedPopup = ({ show, children, fromBottom = true }) => {
  const baseStyling = fromBottom ? {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "1001",
  } : {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    zIndex: "1001",
  }
  const transitions = useTransition(show, {
    from: {
      transform: fromBottom ? "translate3d(0, 100%, 0)" : "translate3d(0, -100%, 0)",
      ...baseStyling
    },
    enter: {
      transform: "translate3d(0, 0%, 0)",
      ...baseStyling
    },
    leave: {
      transform: fromBottom ? "translate3d(0, 100%, 0)" : "translate3d(0, -100%, 0)",
      ...baseStyling
    },
  })

  return (
    <>
      {transitions((style, show) => (
        <animated.div style={{ ...style, ...show ? {} : { pointerEvents: "none" } }}>
          {show &&
            [children]
          }
        </animated.div>
      ))}
    </>
  )
}

AnimatedPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.element,
  fromBottom: PropTypes.bool,
};

export default AnimatedPopup;